// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";

var isAndroid = (function isAndroid() {
    var ua = navigator.userAgent || navigator.vendor || window.opera;
    ua = ua.toLowerCase()
    return (ua.indexOf("android") > -1);
  });

function useAndroidDetector(param) {
  return React.useState(function () {
                return Curry._1(isAndroid, undefined);
              })[0];
}

export {
  isAndroid ,
  useAndroidDetector ,
  
}
/* react Not a pure module */
